export const serviceItems = [
  {
    id: 1,
    imgSrc: "/assets/img/fac-1.jpg",
    number: "01",
    title: "Water Rides",
    description: "Exciting water rides filled with endless fun.",
  },
  {
    id: 2,
    imgSrc: "/assets/img/fac-2.jpg",
    number: "02",
    title: "Children Play Area",
    description: "Kids enjoy safe, joyful playtime experiences.",
  },
  {
    id: 3,
    imgSrc: "/assets/img/fac-3.jpg",
    number: "03",
    title: "Rain Dance",
    description: "Groove under refreshing rain with music.",
  },
  {
    id: 4,
    imgSrc: "/assets/img/fac-4.jpg",
    number: "04",
    title: "Restaurants",
    description: "Tasty food and drinks energize your fun all day.",
  },
  {
    id: 5,
    imgSrc: "/assets/img/fac-5.jpg",
    number: "05",
    title: "Gents & Ladies Shower",
    description: "Separate showers for freh comfortable cleaning.",
  },
  {
    id: 6,
    imgSrc: "/assets/img/fac-6.jpg",
    number: "06",
    title: "Gents & Ladies Changing Room",
    description: "Freshen up comfortably in clean changing rooms.",
  },
  {
    id: 7,
    imgSrc: "/assets/img/fac-7.jpg",
    number: "07",
    title: "Locker",
    description: "Keep your belongings safe and secure with reliable lockers.",
  },
  {
    id: 8,
    imgSrc: "/assets/img/fac-8.jpg",
    number: "08",
    title: "Ample Parking",
    description: "Large parking area for hassle-free convenience.",
  },
];


export const serviceItems2 = [
  {
    id: 9,
    serviceImage: "/assets/img/service/05.jpg",
    barShape: "/assets/img/service/bar.png",
    icon: "/assets/img/icon/07.svg",
    title: "Smart Technology",
    description:
      "It is a long established fact xbliuthat a reader will be distracteda the readable content of a page when looking",
    itemsShape: "/assets/img/service/items-shape.png",
  },
  {
    id: 10,
    serviceImage: "/assets/img/service/05.jpg",
    barShape: "/assets/img/service/bar.png",
    icon: "/assets/img/icon/08.svg",
    title: "Best Engineering",
    description:
      "It is a long established fact xbliuthat a reader will be distracteda the readable content of a page when looking",
    itemsShape: "/assets/img/service/items-shape.png",
  },
  {
    id: 11,
    serviceImage: "/assets/img/service/05.jpg",
    barShape: "/assets/img/service/bar.png",
    icon: "/assets/img/icon/09.svg",
    title: "Chemical Research",
    description:
      "It is a long established fact xbliuthat a reader will be distracteda the readable content of a page when looking",
    itemsShape: "/assets/img/service/items-shape.png",
  },
  {
    id: 12,
    serviceImage: "/assets/img/service/05.jpg",
    barShape: "/assets/img/service/bar.png",
    icon: "/assets/img/icon/10.svg",
    title: "Architecture Design",
    description:
      "It is a long established fact xbliuthat a reader will be distracteda the readable content of a page when looking",
    itemsShape: "/assets/img/service/items-shape.png",
  },
  {
    id: 13,
    serviceImage: "/assets/img/service/05.jpg",
    barShape: "/assets/img/service/bar.png",
    icon: "/assets/img/icon/07.svg",
    title: "Smart Technology",
    description:
      "It is a long established fact xbliuthat a reader will be distracteda the readable content of a page when looking",
    itemsShape: "/assets/img/service/items-shape.png",
  },
  {
    id: 14,
    serviceImage: "/assets/img/service/05.jpg",
    barShape: "/assets/img/service/bar.png",
    icon: "/assets/img/icon/08.svg",
    title: "Best Engineering",
    description:
      "It is a long established fact xbliuthat a reader will be distracteda the readable content of a page when looking",
    itemsShape: "/assets/img/service/items-shape.png",
  },
  {
    id: 15,
    serviceImage: "/assets/img/service/05.jpg",
    barShape: "/assets/img/service/bar.png",
    icon: "/assets/img/icon/09.svg",
    title: "Chemical Research",
    description:
      "It is a long established fact xbliuthat a reader will be distracteda the readable content of a page when looking",
    itemsShape: "/assets/img/service/items-shape.png",
  },
  {
    id: 16,
    serviceImage: "/assets/img/service/05.jpg",
    barShape: "/assets/img/service/bar.png",
    icon: "/assets/img/icon/10.svg",
    title: "Architecture Design",
    description:
      "It is a long established fact xbliuthat a reader will be distracteda the readable content of a page when looking",
    itemsShape: "/assets/img/service/items-shape.png",
  },
];

export const services = [
  {
    id: 17,
    image: "/assets/img/service/01.jpg",
    icon: "/assets/img/icon/01.svg",
    number: "01",
    title: "Building Construction",
    description: "Consectetur Phasellus a odio vel sapien pharetra placerat.",
    delay: ".2s",
  },
  {
    id: 18,
    image: "/assets/img/service/02.jpg",
    icon: "/assets/img/icon/02.svg",
    number: "02",
    title: "Architecture Design",
    description: "Consectetur Phasellus a odio vel sapien pharetra placerat.",
    delay: ".4s",
  },
  {
    id: 19,
    image: "/assets/img/service/03.jpg",
    icon: "/assets/img/icon/03.svg",
    number: "03",
    title: "Building Renovation",
    description: "Consectetur Phasellus a odio vel sapien pharetra placerat.",
    delay: ".6s",
  },
  {
    id: 20,
    image: "/assets/img/service/06.jpg",
    icon: "/assets/img/icon/07.svg",
    number: "04",
    title: "Smart Technology",
    description: "Consectetur Phasellus a odio vel sapien pharetra placerat.",
    delay: ".2s",
  },
  {
    id: 21,
    image: "/assets/img/service/07.jpg",
    icon: "/assets/img/icon/08.svg",
    number: "05",
    title: "Best Engineering",
    description: "Consectetur Phasellus a odio vel sapien pharetra placerat.",
    delay: ".4s",
  },
  {
    id: 22,
    image: "/assets/img/service/08.jpg",
    icon: "/assets/img/icon/09.svg",
    number: "06",
    title: "Chemical Research",
    description: "Consectetur Phasellus a odio vel sapien pharetra placerat.",
    delay: ".6s",
  },
];

export const services2 = [
  {
    id: 23,
    title: "Construction",
  },
  {
    id: 24,
    title: "House Renovation",
  },
  {
    id: 25,
    title: "Material Supply",
  },
  {
    id: 26,
    title: "Project Management",
  },
  {
    id: 27,
    title: "Heating and Water",
  },
];

export const allServices = [
  ...serviceItems,
  ...serviceItems2,
  ...services,
  ...services2,
];
